export default "/list/static/images/lodging_v2.svg";